module.exports = __webpack_public_path__ + "static/media/CYC-BNB.921078c0.svg";